/* JAWS Sticky ATC controller.
 * Strategy (proxy pattern, version-tolerant):
 *  - Reveal the bar once Horizon's real Add-to-Cart button scrolls out of view.
 *  - Mirror live price + availability from an embedded variant map keyed by variant id,
 *    so we never depend on Horizon's internal price CSS classes.
 *  - Forward the tap to Horizon's native add-to-cart button → variant, quantity,
 *    sold-out handling and the cart drawer all stay 100% native. No second form.
 */
(function () {
  function init(bar) {
    if (!bar || bar.dataset.jawsInit === '1') return;
    bar.dataset.jawsInit = '1';

    var main = document.getElementById('MainContent') || document;

    // Horizon's real add-to-cart button (never the one inside this bar).
    var mainAddBtn = main.querySelector('add-to-cart-component button[name="add"], #vp-form button[name="add"], button[name="add"]');
    // The product form that holds the selected variant id.
    var form = main.querySelector('product-form-component form, form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('[name="id"]') : null;

    var priceEl = bar.querySelector('[data-jaws-atc-price]');
    var addBtn = bar.querySelector('[data-jaws-atc-add]');
    var addLabel = bar.querySelector('[data-jaws-atc-add-label]');
    var sizesBtn = bar.querySelector('[data-jaws-atc-sizes]');

    // Variant map embedded by the snippet: { "<id>": { price, available } }
    var variants = {};
    var json = bar.querySelector('[data-jaws-atc-variants]');
    if (json) {
      try { variants = JSON.parse(json.textContent || '{}'); } catch (e) { variants = {}; }
    }

    var soldOutText = bar.getAttribute('data-sold-out-text') || 'Sold out';
    var addText = addLabel ? addLabel.textContent : 'Add to cart';

    function currentId() {
      if (idInput && idInput.value) return String(idInput.value);
      return bar.getAttribute('data-default-variant') || '';
    }

    function sync() {
      var v = variants[currentId()];
      if (!v) return;
      if (priceEl && v.price) priceEl.innerHTML = v.price;
      var available = v.available !== false;
      bar.classList.toggle('is-sold-out', !available);
      if (addBtn) {
        addBtn.disabled = !available;
        if (addLabel) addLabel.textContent = available ? addText : soldOutText;
      }
    }

    // Toggle visibility + a11y state together: while off-screen the bar is inert
    // and aria-hidden, so keyboard/screen-reader users never land on a hidden button.
    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !v;
    }
    setVisible(false);

    // Reveal/hide based on the real ATC's visibility.
    if (mainAddBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show the sticky bar only when the real ATC is NOT on screen.
          setVisible(!entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(mainAddBtn);
    } else {
      // No real ATC found (or no IO support): leave the bar hidden rather than guess.
      setVisible(false);
    }

    // Forward the tap to Horizon's native button.
    if (addBtn && mainAddBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        mainAddBtn.click();
      });
    }

    // "Select size" → scroll the real variant picker into view.
    if (sizesBtn) {
      sizesBtn.addEventListener('click', function () {
        var picker = main.querySelector('variant-picker, .variant-picker, [class*="variant"]');
        if (picker && picker.scrollIntoView) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    // Keep price/availability in sync as the shopper changes variants.
    if (form) form.addEventListener('change', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-jaws-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
